import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  scenicAccordionItem: {
    width: '100%',
    height: '100%',
    background: theme.palette.blue.light100,
    position: 'relative',
  },
  bgImageContainer: {
    position: 'absolute',
    top: 45,
    left: 0,
    height: 'calc(100% - 85px)',
    width: '100%',
    zIndex: 0,
  },
  bgImage: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  saiCardContainer: {
    padding: '0 32px 12px',
    position: 'relative',
  },
  saiCard: {
    width: '100%',
    padding: '40px 34px',
    borderRadius: 8,
    background: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    textAlign: 'center',
    '&>div': {
      display: 'flex',
      flexDirection: 'column-reverse',
      gap: '2rem',
    },
  },
  heading: {
    ...theme.typography.h2,
    marginBottom: 20,
    marginTop: 12,
  },
  supportiveCopy: {
    maxWidth: 732,
    marginBottom: 0,
  },
  starPointlistContainer: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    marginTop: 25,
    textAlign: 'left',
  },
  starPointlistItem: {
    ...theme.typography.h6,
    color: theme.palette.secondary.light,
    fontSize: '14px !important',
    borderBottom: `0.5pt solid ${theme.palette.secondary.dark}`,
    padding: '15px 0',
    display: 'flex',
    alignItems: 'center',
  },
  starPoint: {
    borderRadius: '50%',
    width: 24,
    height: 24,
    flexBasis: 24,
    flexShrink: 0,
    background: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  starIcon: {
    fontSize: '.75rem',
    color: theme.palette.primary.main,
  },
}))

export default useStyles
